import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";
import cmsClient from "src/services/cmsClient";

const createQuickLink = async (payload: Partial<IQuickLink>) => {
	const response = await cmsClient.post<IQuickLink>(
		"/homepage/admin/quicklink/",
		payload
	);

	return response.data;
};

const useCreateQuickLink = () => {
	const queryClient = useQueryClient();

	const onSuccess = () => {
		toast.success(
			<CustomToast type="Success" message="Quick link created successfully" />,
			{ hideProgressBar: true }
		);

		queryClient.invalidateQueries(["quick-links"]);
	};

	const onError = () => {
		toast.error(
			<CustomToast type="Error" message="Something went wrong, try again" />,
			{ hideProgressBar: true }
		);
	};

	const mutation = useMutation(createQuickLink, {
		onError,
		onSuccess
	});

	return mutation;
};

export default useCreateQuickLink;
